import get from 'lodash/get';

// -----------------------------------------------------------

const DEFAULT_THRESHOLD = 150;

class DpiThreshold {
  constructor(dpi) {
    this.dpi = dpi || Infinity;
  }

  get isTooLow() {
    return this.dpi < DpiThreshold.lowThreshold;
  }

  static get lowThreshold() {
    return get(wkData, 'poor_dpi_threshold', DEFAULT_THRESHOLD);
  }
}

// -----------------------------------------------------------

export default DpiThreshold;
